"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var styling_1 = require("@uifabric/styling");
var utilities_1 = require("@uifabric/utilities");
/**
 * Theme provider is a simplified version of Customizer that activates the appropriate theme data
 * for a given scheme name.
 *
 * @param providers - Injected providers for accessing theme data and providing it via a Customizer component.
 */
exports.ThemeProvider = function (props) {
    var scheme = props.scheme, theme = props.theme, rest = tslib_1.__rest(props, ["scheme", "theme"]);
    // TODO: consider merging implementation with theme-proto, which only stores a reference / scheme name to theme in context
    //        and uses quick global store accessor to trigger change by passing in theme object as child and triggering re-render.
    //        (perf benefits need verification)
    // tslint:disable-next-line:typedef
    var contextTransform = function (context) {
        return styling_1.getThemedContext(context, scheme, theme);
    };
    return React.createElement(utilities_1.Customizer, tslib_1.__assign({}, rest, { contextTransform: contextTransform }));
};
//# sourceMappingURL=ThemeProvider.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@uifabric/foundation/lib-commonjs/ThemeProvider.js
// module id = 1044
// module chunks = 0